export function isConsultorioStandardProfile(profile) {
  return profile.tipo === 'padrao' && ['medico', 'recepcao', 'recepcionista'].includes(profile.key);
}
